import queryString from 'query-string'

import Base from './base'
import { CalendarSettings } from '../types/meetings'
import { MeetingType, RenderedContent } from '../types/loft'

export default class Meetings extends Base {
  getTeamCalendars(): Promise<unknown> {
    return this.api.get('team_calendars?active=true')
  }

  getMeetingsTeamSettings(): Promise<unknown> {
    return this.api.get('meetings_team_settings')
  }

  getMeetingTypes(): Promise<{ data: MeetingType[] }> {
    return this.api.get('meeting_types?shared=true&round_robin=false')
  }

  createRenderedContents(payload: Record<string, unknown>): Promise<{ data: RenderedContent[] }> {
    return this.api.post('/rendered_contents/meetings', payload)
  }

  getRemoteCalendarEvents(params: Record<string, string>): Promise<unknown> {
    return this.api.get(
      `remote_calendar_events?from=${params.from}&to=${params.to}&calendar_type=${
        params.calendar_type
      }&${queryString.stringify({ calendar_id: params.calendar_id, user_guid: params.user_guid })}`
    )
  }

  createMeetingPaths(payload: Record<string, unknown>): Promise<unknown> {
    return this.api.post('calendar_meeting_paths', payload)
  }

  getDistributionSettings(): Promise<unknown> {
    return this.api.get('distribution_settings')
  }

  getCalendarSettings(): Promise<{ data: CalendarSettings }> {
    return this.api.get('calendar_settings')
  }
}
